import Vue from 'vue'
import App from './App.vue'
import api from './api'
import router from './router'
import store from './store'
import storage from './utils/storage'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import VueI18n from 'vue-i18n'
import { getCookie, setCookie } from './utils'
import moment from 'moment';
import VueClipboard from 'vue-clipboard2'
Vue.use(Antd);

Vue.use(VueClipboard)
Vue.prototype.$bus = new Vue({})
Vue.prototype.$api = api
Vue.prototype.$storage = storage
Vue.config.productionTip = false
// const token = 'bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOi8vZGV2LWFwaS5ncWpjcy5jb20vbG9naW4iLCJpYXQiOjE3NTA0ODQzOTYsImV4cCI6MTc1NDA4NDM5NiwibmJmIjoxNzUwNDg0Mzk2LCJqdGkiOiJ2M1BqN0ZSQ1drTFYwSFBDIiwic3ViIjo1NzE4NiwicHJ2IjoiODdlMGFmMWVmOWZkMTU4MTJmZGVjOTcxNTNhMTRlMGIwNDc1NDZhYSJ9.EVKRUBDsL8j4lf9HaqbNTUltkNbZYfHc70mbGFaEa8g'
const token = getCookie('token') || false
console.info('token', token)
if (token) {
	// storage.set('token', token)
	setCookie('token', token)
	store.dispatch('setToken', token)
}
Vue.use(VueI18n)
const locale = 'zh-CN' // storage.get('language') || navigator.language || 'en-US'
const i18n = new VueI18n({
	locale,
	messages: {
		'zh-CN': require('@/assets/languages/zh-CN.json'),
		// 'en-US': require('@/assets/languages/en-US.json'),
		// 'vi': require('@/assets/languages/vi.json')
	}
})
store.dispatch('setLanguage', locale)
moment.locale(locale)

new Vue({
	router,
	store,
	i18n,
	render: h => h(App)
}).$mount('#app')
